import axios from 'axios';

const responder = (data) => {
  if (data.id != null) {
    return axios.put(`/fornecedor/respostas-cotacao-conjunta/${data.id}`, data);
  }
  return axios.post('/fornecedor/respostas-cotacao-conjunta', data);
};
const notificarNegociacao = (idResposta) => axios.post(`/notificacoes/negociacao_cotacao_conjunta/${idResposta}`, {});

export default {
  responder,
  notificarNegociacao,
};
